import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SectionTabs from '../components/SectionTabs';
import KeepQueryRedirect from '../components/KeepQueryRedirect';
import { SALES_TABS } from '../utils/navMap';
import DashboardPage from './DashboardPage';
import ProductsPage from './ProductsPage';
import InsightsPage from './InsightsPage';
import TimeAnalysisPage from './TimeAnalysisPage';
import FinancialsPage from './FinancialsPage';
import HistoryPage from './HistoryPage';
import WeatherPage from './WeatherPage';

const ROOMS: Record<string, React.ReactElement> = {
  overview: <DashboardPage />, products: <ProductsPage />, insights: <InsightsPage />,
  time: <TimeAnalysisPage />, financials: <FinancialsPage />, history: <HistoryPage />,
  weather: <WeatherPage />,
};

export default function SalesPage() {
  return (
    <div>
      <SectionTabs label="Sales" tabs={SALES_TABS} />
      <Routes>
        {Object.entries(ROOMS).map(([slug, el]) => <Route key={slug} path={slug} element={el} />)}
        <Route path="*" element={<KeepQueryRedirect to="/sales/overview" />} />
      </Routes>
    </div>
  );
}
